import {InvalidArgumentException} from "@livechat/tags";
import {PropertiesOnly} from "@livechat/shared";

export class AnswerTemplateAggregate {
  readonly idAnswerTemplate: number;
  readonly title: string;
  readonly content: string;
  readonly companiesIds: Array<string>;

  private constructor(idAnswerTemplate: number, title: string, content: string, companiesIds: Array<string>) {
    this.idAnswerTemplate = idAnswerTemplate;
    this.title = title;
    this.content = content;
    this.companiesIds = companiesIds;

    this.validate(this);
  }

  public static getInstance(props: PropertiesOnly<AnswerTemplateAggregate>) {
    const { idAnswerTemplate, content, title, companiesIds} = props;

    return new AnswerTemplateAggregate(idAnswerTemplate, title, content, companiesIds);
  }

  private validate(aggregate: AnswerTemplateAggregate) {
    if (!aggregate.title) {
      throw new InvalidArgumentException('title', 'required');
    }

    if (!aggregate.content) {
      throw new InvalidArgumentException('content', 'required');
    }

    if (!aggregate.companiesIds?.length) {
      throw new InvalidArgumentException('companiesIds', 'required');
    }
  }
}
